import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import TextRecommendationEmpty from '@/features/why-to-watch/components/TextRecommendationEmpty.vue';
import Top10TitleSwiper from '@/components/popular/provider-module/Top10TitleSwiper.vue';
import TextRecommendationCard from '@/features/why-to-watch/components/TextRecommendationCard.vue';

import { TitleDetail } from '@/interfaces/title-details-graphql';
import { useLanguageStore, useUserStore } from '@/helpers/composables/useStores';

import {
	GetTextRecommendationsDocument,
	GetTextRecommendationsQuery,
	GetTextRecommendationsQueryVariables,
} from '@/features/why-to-watch/graphql/queries/GetTextRecommendations.query';

import { useQuery } from '@/helpers/composables/useApollo';
import { SnowplowContext } from '@/helpers/tracking/providers';

import PromotionsConfig from '@/features/promotions/config.json';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextRecommendations',
  props: {
    title: null,
    additionalContexts: null
  },
  setup(__props: any) {

const props = __props as {
	title: TitleDetail;
	additionalContexts: SnowplowContext[];
};



const { language, country } = useLanguageStore();
const { isAdmin, isEditor, profileInfo, profileIsComplete, isLoggedIn } = useUserStore();

const textRecommendationUserCountries = PromotionsConfig.w2w.pro_users_countries;

const { result } = useQuery<GetTextRecommendationsQuery, GetTextRecommendationsQueryVariables>(
	GetTextRecommendationsDocument,
	() => ({
		language: language.value,
		country: country.value,
		jwEntityId: props.title.id,
	}),
	{
		errorPolicy: 'all',
	}
);

const textRecommendations = computed(() => result.value?.textRecommendations ?? []);

const singleTextRecommendation = computed(() => textRecommendations.value.length === 1);

const showTextRecommendationTools = computed(() => {
	if (!isLoggedIn.value) return false;

	if (isAdmin.value || isEditor.value) {
		return true;
	} else if (!textRecommendationUserCountries.includes(country.value)) {
		return false;
	}

	const profileCountry = profileInfo.value?.country;
	return profileIsComplete.value ? isLoggedIn.value && profileCountry === country.value : isLoggedIn.value;
});

return { __sfc: true,props, language, country, isAdmin, isEditor, profileInfo, profileIsComplete, isLoggedIn, textRecommendationUserCountries, result, textRecommendations, singleTextRecommendation, showTextRecommendationTools, HiddenHorizontalScrollbar, TextRecommendationEmpty, Top10TitleSwiper, TextRecommendationCard }
}

})